import { AnyRoute, createRoute, redirect } from '@tanstack/react-router'
import { REPORTS_PATH } from 'commons/constants/routes'
import { Request } from 'commons/utils/request/request'

import { BankReportsWrapper } from './BankReportsWrapper'
import {
  Overview,
  alertsReportRoute,
  applicationPipelineReportRoute,
  clientPortalUsersActivityReportRoute,
  emailHistoryReportRoute,
  relationshipsReportRoute,
  siteAuditDocumentsReportRoute,
  userReportRoute
} from './routes'
import { documentStatusReportRoute } from './routes/DocumentStatusReport'

export const routeReportsTree = <T extends AnyRoute>(rootRoute: T) => {
  const reportsIndexRoute = createRoute({
    beforeLoad: async ({ context }) => {
      if (!context.accessibleRoutingFlags.reportRootAccess) {
        throw redirect({
          to: '/'
        })
      }
    },
    getParentRoute: () => rootRoute,
    path: REPORTS_PATH,
    component: BankReportsWrapper,
    loader: () => Request.get(Request.urls.bank.portalReport)
  })

  const overviewRoute = createRoute({
    getParentRoute: () => reportsIndexRoute,
    path: '/',
    component: Overview
  })

  return reportsIndexRoute.addChildren([
    applicationPipelineReportRoute<typeof reportsIndexRoute>(reportsIndexRoute),
    clientPortalUsersActivityReportRoute<typeof reportsIndexRoute>(reportsIndexRoute),
    relationshipsReportRoute<typeof reportsIndexRoute>(reportsIndexRoute),
    siteAuditDocumentsReportRoute<typeof reportsIndexRoute>(reportsIndexRoute),
    userReportRoute<typeof reportsIndexRoute>(reportsIndexRoute),
    emailHistoryReportRoute<typeof reportsIndexRoute>(reportsIndexRoute),
    alertsReportRoute<typeof reportsIndexRoute>(reportsIndexRoute),
    documentStatusReportRoute<typeof reportsIndexRoute>(reportsIndexRoute),
    overviewRoute
  ])
}
